module.exports = __webpack_public_path__ + "static/media/repair-icon.caf6c6d4.svg";